import { apiGet } from "../ApiMethod";
import { setFirmwareData } from "../../mappers";
import { CheckValue } from "../../service";

export const firmwareList = async (data = {}, config = {}) => {
  const response = await apiGet("_firmware", data, null, config);
  const firmware = CheckValue(response?.data?.firmware) ? response.data?.firmware : [];
  return {
    ...response,
    rowData: firmware.map(setFirmwareData),
  };
};